<template>
    <div class="dashboard-boxed-container" v-if="apiKeys.length > 0">
        <div class="api-keys-container">
            <span class="dashboard-subtitle mb-5">API keys</span>

            <v-row class="font-weight-bold mb-4">
                <v-col sm="4" class="dashboard-column-title">
                    API key name
                </v-col>
                <v-col sm="4" class="dashboard-column-title text-center">
                    Status
                </v-col>
                <v-col sm="4" class="dashboard-column-title text-center">
                    Action
                </v-col>
            </v-row>

            <v-row v-for="apiKey in apiKeys" :key="apiKey.id" style="height: 70px;" class="align-center">
                <v-col sm="4">
                    <span>{{ apiKey.name }}</span>
                </v-col>

                <v-col sm="4" class="text-center">
                    <span>{{ apiKey.status }}</span>
                </v-col>

                <v-col sm="4" class="text-center">
                    <v-btn v-if="apiKey.status == 'active'" class="btn-danger rounded-xl text-center" outlined large
                           @click="invalidateAPIKey(apiKey.id)"
                    >
                        Invalidate
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </div>

    <div v-else></div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ListAPIKeys",
    data() {
        return {
            apiKeys: [],
        }
    },

    created() {
        this.getAPIKeys();
    },

    computed: {
        ...mapState('User', ['account']),
    },

    methods: {
        async getAPIKeys() {
            let response = await this.$apiService.get(`accounts/${this.account.id}/api-keys`);
            this.apiKeys = response.data;
        },

        async invalidateAPIKey(id) {
            let response = await this.$apiService.post(`accounts/${this.account.id}/api-key-invalidate/${id}`);
            await this.getAPIKeys();
        },
    }
}
</script>